/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EvaFoam } from '../../models/eva-foam';
import { UpdateEvaFoamDto } from '../../models/update-eva-foam-dto';

export interface UpdateOneBaseMgmtEvaFoamControllerEvaFoam$Params {
  id: number;
      body: UpdateEvaFoamDto
}

export function updateOneBaseMgmtEvaFoamControllerEvaFoam(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<StrictHttpResponse<EvaFoam>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtEvaFoamControllerEvaFoam.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EvaFoam>;
    })
  );
}

updateOneBaseMgmtEvaFoamControllerEvaFoam.PATH = '/api/mgmt/eva-foam/{id}';
